import {gql} from '@apollo/client';

export const FILTERS = gql`
  query UsedFiltersData($zipcode: String!, $distance: Int!) {
    usedFilter: getUsedDefaultFilterByZipAndDistance(
      zipcode: $zipcode
      distance: $distance
    ) {
      fuelType
      exteriorColor
      interiorColor
      modelYear
      transmissionType
      modelName
    }
  }
`;
